export default function Tabs() {
  return {}
}
